<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container big-container">
        <div class="row mt-20">
          <div class="col-sm-12">
            <div class="content-header-info">
              <div class="col-sm-12">
                <button
                  v-if="isAllowToExport"
                  class="btn btn-primary pull-left"
                  @click="openExportModal()"
                >
                  <span><i class="ic-download"></i></span>Export
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    {{ rentalLabel }} &amp; {{ airportLabel }} Bookings
                    <span><i class="ic-booking-history"></i></span>
                  </h2>
                  <p>Manage and view all transactions.</p>
                </div>
              </div>
            </div>
          </div>
          <!-- /.col-sm-8 -->
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <section>
      <div class="container big-container">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <div class="btn-group mb-15" role="group" aria-label="...">
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': !isAirportType && !isHourlyType }"
                  @click="onChangeServiceType('Unspecified')"
                >
                  All
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': isAirportType }"
                  @click="onChangeServiceType('AirportTransfer')"
                >
                  Airport Transfer
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': isHourlyType }"
                  @click="onChangeServiceType('Rental')"
                >
                  Hourly
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container big-container">
        <div class="row">
          <div class="col-sm-4">
            <label for="search">Search</label>
            <div class="dataTables_filter" id="filter-search">
              <i class="ic-search"></i>
              <input
                id="search"
                type="search"
                class="form-control"
                v-model="requestParams.keyword"
                placeholder="Search"
              />
            </div>
          </div>
          <div class="col-sm-4">
            <label>Pickup Date</label>
            <div class="dataTables_filter">
              <i class="ic-date-picker"></i>
              <VueCtkDateTimePicker
                v-model="requestParams.pickupDate"
                id="mutation-start-pickup"
                color="#025BC5"
                format="MM/DD/YYYY"
                formatted="LL"
                range
                auto-close
                only-date
                no-label
                no-header
                no-button
                no-button-now
              />
            </div>
          </div>
          <div class="col-sm-4">
            <label>Reservation Status</label>
            <v-select
              class="v-search-select"
              placeholder="Status"
              label="text"
              v-model="requestParams.status"
              :options="statusTypes"
              :clearable="true"
              :searchable="true"
              :filterable="true"
              :reduce="(option) => option.value"
              @input="changeStatusFilter()"
            />
          </div>
          <div class="col-sm-4" style="margin-top: 20px">
            <label for="search">Payment Status</label>
            <v-select
              class="v-search-select"
              placeholder="Payment Status"
              label="text"
              v-model="requestParams.paymentStatus"
              :options="paymentStatus"
              :clearable="true"
              :searchable="true"
              :filterable="true"
              :reduce="(option) => option.value"
              :disabled="requestParams.status === 'Tentative'"
            />
          </div>
          <div class="col-sm-4" style="margin-top: 20px">
            <label>Progress</label>
            <v-select
              class="v-search-select"
              placeholder="Progress"
              label="text"
              v-model="requestParams.progress"
              :options="progressTypes"
              :clearable="true"
              :searchable="true"
              :filterable="true"
              :reduce="(option) => option.value"
              :disabled="requestParams.status === 'Cancelled'"
            />
          </div>
          <div class="col-sm-4" style="margin-top: 20px">
            <label>Company</label>
            <v-select
              class="v-search-select"
              placeholder="Company"
              label="name"
              v-model="requestParams.companyIds"
              :options="companies"
              :clearable="true"
              :searchable="true"
              :filterable="true"
              :reduce="(option) => option.id"
            />
          </div>
          <div class="col-sm-5" style="margin-top: 25px">
            <div class="dataTables_filter">
              <div class="d-flex" style="gap: 10px">
                <button class="search-button" @click="onSearchReportList(true)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 20 20"
                  >
                    <g fill="none">
                      <path
                        d="M8.5 3a5.5 5.5 0 0 1 4.383 8.823l4.147 4.147a.75.75 0 0 1-.976 1.133l-.084-.073l-4.147-4.147A5.5 5.5 0 1 1 8.5 3zm0 1.5a4 4 0 1 0 0 8a4 4 0 0 0 0-8z"
                        fill="currentColor"
                      ></path>
                    </g>
                  </svg>
                  Search
                </button>
                <button class="clear-button" @click="resertFilter()">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 512 512"
                  >
                    <path
                      d="M289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34z"
                      fill="currentColor"
                    ></path>
                  </svg>
                  Clear All
                </button>
              </div>
            </div>
          </div>
          <div class="col-sm-7" style="margin-top: 25px">
            <div class="dataTables_length">
              <label>
                <span>Sort by: </span>
                <select
                  class="form-control v-select"
                  v-model="requestParams.sort"
                  style="width: 250px"
                  @change="(e) => onSelectSort(e.target.value)"
                >
                  <option
                    v-for="item in sortByOption"
                    :value="item.value"
                    :key="item.value"
                  >
                    {{ item.label }}
                  </option>
                </select>
              </label>
              <label>
                <select
                  class="form-control v-select"
                  v-model="requestParams.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in pageSizeOption"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
              </label>
            </div>
          </div>
        </div>

        <!-- /.row -->
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive table-manage">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th class="text-center">Type</th>
                    <th>Code</th>
                    <th>Booker</th>
                    <th>Passenger</th>
                    <th>Vehicle</th>
                    <th class="single-line-text">Reservation Pick-up</th>
                    <th>Pick-Up</th>
                    <th>Drop-Off</th>
                    <th>Payment</th>
                    <th class="text-center">Progress</th>
                    <th class="text-right">Buying</th>
                    <th class="text-right">Selling</th>
                    <th class="text-right">Incentive</th>
                    <th class="text-right">Profit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="detail-row" v-for="item in items" :key="item.id">
                    <td class="text-center">
                      <strong>
                        <i
                          v-if="
                            isAirportTransfer(item.serviceType) &&
                            item.pickUpLocation.isAirportZone
                          "
                          class="ic-flight-icon"
                        ></i>
                        <i
                          v-else-if="
                            isAirportTransfer(item.serviceType) &&
                            item.dropOffLocation.isAirportZone
                          "
                          class="ic-flight-departure-icon"
                        ></i>
                        <i
                          class="ic-car-alt"
                          v-else-if="
                            isAirportTransfer(item.serviceType) &&
                            !item.pickUpLocation.isAirportZone &&
                            !item.dropOffLocation.isAirportZone
                          "
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            viewBox="0 0 1200 1200"
                          >
                            <path
                              fill="currentColor"
                              d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                            />
                          </svg>
                        </i>
                        <i v-else class="ic-time"></i>

                        <!-- <i
                          :class="{
                            'ic-flight-icon': isAirportTransfer(
                              item.serviceType
                            ),
                            'ic-time': !isAirportTransfer(item.serviceType),
                          }"
                        ></i> -->
                      </strong>
                    </td>
                    <td>
                      <span
                        class="help-tip cursor-pointer"
                        tabindex="0"
                        data-container="body"
                        data-toggle="popover"
                        data-placement="top"
                        :data-content="
                          item.errorMessage ? item.errorMessage : '  '
                        "
                        v-if="item.isError"
                      >
                        &#33;
                      </span>
                      <a
                        href="javascript:void(0)"
                        class="view-detail-link"
                        @click.prevent="open(item)"
                      >
                        {{ item.code }}
                      </a>
                    </td>
                    <td>
                      <strong>{{ item.booker.company }}</strong>
                      <span class="new-line">
                        {{ item.booker.title ? `${item.booker.title}.` : "" }}
                        {{ item.booker.fullName }}
                      </span>
                    </td>
                    <td>
                      <strong>{{ item.passenger.company }}</strong>
                      <span class="new-line">
                        {{
                          item.passenger.title ? `${item.passenger.title}.` : ""
                        }}
                        {{ item.passenger.fullName }}
                      </span>
                    </td>
                    <td>
                      {{ item.vehicle.className }}
                      <span v-if="item.vehicle">
                        <span class="new-line">
                          {{ item.vehicle.factoryName }}
                          {{ item.vehicle.brandName }}
                        </span>
                        <span class="new-line" v-if="item.vehicle.plateNumber">
                          ({{ item.vehicle.plateNumber }})
                        </span>
                      </span>
                    </td>
                    <td>
                      {{
                        $helper.dateFormatted(item.originalPickUpTime.dateTime)
                      }}
                      <strong>{{
                        $helper.timeFormatted(item.originalPickUpTime.dateTime)
                      }}</strong>
                      <span class="utc-style"
                        >({{ item.originalPickUpTime.timezone }})</span
                      >
                    </td>
                    <td>
                      {{ $helper.dateFormatted(item.pickUpDate.dateTime) }}
                      <strong>{{
                        $helper.timeFormatted(item.pickUpDate.dateTime)
                      }}</strong>
                      <span class="utc-style"
                        >({{ item.pickUpDate.timezone }})</span
                      >
                    </td>
                    <td>
                      {{ $helper.dateFormatted(item.dropOffDate.dateTime) }}
                      <strong>{{
                        $helper.timeFormatted(item.dropOffDate.dateTime)
                      }}</strong>
                      <span class="utc-style"
                        >({{ item.dropOffDate.timezone }})</span
                      >
                    </td>
                    <td
                      style="display: text-inline"
                      :class="{
                        '--green35':
                          item.paymentStatus === 'Complete' ||
                          item.paymentStatus === 'Refunded',
                        'sts-danger':
                          item.paymentStatus === 'Unpaid' ||
                          item.paymentStatus === 'RefundRequested',
                      }"
                    >
                      {{
                        item.paymentStatus === "Complete"
                          ? "Completed"
                          : humanize(item.paymentStatus)
                      }}
                      <span
                        style="color: #212121"
                        v-if="item.paymentInfo === 'Monthly Invoice'"
                        >({{ item.paymentInfo }})</span
                      >
                    </td>
                    <td class="text-center">
                      <span
                        :class="{
                          'sts_job-open': item.progress === 'Open',
                          'sts_job-run': item.progress === 'Run',
                          'sts_job-done': item.progress === 'Done',
                          'sts_job-closed': item.progress === 'Close',
                          'sts_job-aborted': item.progress === 'Abort',
                          'sts_job-rescue_operation':
                            item.progress === 'RescueOperation',
                          'sts_job-under-review':
                            item.progress === 'UnderReview',
                        }"
                      ></span>
                    </td>
                    <td class="text-right">
                      <span v-if="item.rates.buying"
                        >{{ item.rates.currencyCode }}
                        {{
                          $currencyFormat(
                            item.rates.currencyCode,
                            item.rates.buying
                          )
                        }}
                      </span>
                      <span v-else class="sts-danger">N/A</span>
                    </td>
                    <td class="text-right">
                      {{ item.rates.currencyCode }}
                      {{
                        $currencyFormat(
                          item.rates.currencyCode,
                          item.rates.selling
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{ item.rates.currencyCode }}
                      {{
                        $currencyFormat(
                          item.rates.currencyCode,
                          item.rates.incentive
                        )
                      }}
                    </td>
                    <td class="text-right">
                      <span v-if="item.rates.buying"
                        >{{ item.rates.currencyCode }}
                        {{
                          $currencyFormat(
                            item.rates.currencyCode,
                            item.rates.profit
                          )
                        }}</span
                      >
                      <span v-else class="sts-danger">N/A</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- /.row -->
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="requestParams.page"
                :page-count="requestParams.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
        <!-- /.row -->
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="exportmodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10">
                <h4>Export Report</h4>
                <h6>Please fill all information below.</h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <form action="#" id="vueform" role="form">
                    <div class="form-group">
                      <label>Filter Date</label>
                      <v-select
                        class="v-search-select"
                        placeholder=""
                        label="text"
                        v-model="exportParam.filterDate"
                        :options="filterDateOption"
                        :clearable="false"
                        :searchable="true"
                        :filterable="true"
                        :reduce="(option) => option.value"
                        @input="(value) => onChangeFilterDate(value)"
                      >
                      </v-select>
                    </div>
                    <div
                      class="form-group"
                      v-if="this.exportParam.filterDate === 'Pick-Up Date'"
                    >
                      <label>Pick-up Range</label>
                      <VueCtkDateTimePicker
                        id="mutation-start"
                        v-model="exportParam.pickupRange"
                        color="#025BC5"
                        format="MM/DD/YYYY"
                        formatted="LL"
                        range
                        auto-close
                        only-date
                        no-label
                        no-header
                        no-button
                        no-button-now
                      />
                    </div>
                    <div
                      class="form-group"
                      v-if="this.exportParam.filterDate === 'Reservation Date'"
                    >
                      <label>Reservation Range</label>
                      <VueCtkDateTimePicker
                        id="mutation-start"
                        v-model="exportParam.reservationRange"
                        color="#025BC5"
                        format="MM/DD/YYYY"
                        formatted="LL"
                        range
                        auto-close
                        only-date
                        no-label
                        no-header
                        no-button
                        no-button-now
                      />
                    </div>
                    <div class="form-group">
                      <label>Reservation Status</label>
                      <v-select
                        class="v-search-select"
                        placeholder="Status"
                        label="text"
                        v-model="exportParam.status"
                        :options="statusTypes"
                        :clearable="true"
                        :searchable="true"
                        :filterable="true"
                        :reduce="(option) => option.value"
                        @input="changeStatusExport()"
                      >
                        <template #search="{ attributes, events }">
                          <input
                            class="vs__search"
                            name="statusType"
                            :required="!exportParam.status"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-select>
                      <small
                        class="form-text text-danger"
                        v-if="validationErrors.status"
                        v-text="validationErrors.status"
                      ></small>
                    </div>
                    <div class="form-group">
                      <label>Payment Status</label>
                      <v-select
                        class="v-search-select"
                        placeholder="Payment Status"
                        label="text"
                        v-model="exportParam.paymentStatus"
                        :options="paymentStatus"
                        :clearable="true"
                        :searchable="true"
                        :filterable="true"
                        :reduce="(option) => option.value"
                        :disabled="exportParam.status === 'Tentative'"
                      >
                        <template #search="{ attributes, events }">
                          <input
                            class="vs__search"
                            name="paymentStatus"
                            :required="!exportParam.paymentStatus"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-select>
                      <small
                        class="form-text text-danger"
                        v-if="validationErrors.paymentStatus"
                        v-text="validationErrors.paymentStatus"
                      ></small>
                    </div>
                    <div class="form-group">
                      <label>Progress Type</label>
                      <v-select
                        class="v-search-select"
                        placeholder="Progress"
                        label="text"
                        v-model="exportParam.progress"
                        :options="progressTypes"
                        :clearable="true"
                        :searchable="true"
                        :filterable="true"
                        :reduce="(option) => option.value"
                        :disabled="exportParam.status === 'Cancelled'"
                      >
                        <template #search="{ attributes, events }">
                          <input
                            class="vs__search"
                            name="progressType"
                            :required="!exportParam.progressType"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-select>
                      <small
                        class="form-text text-danger"
                        v-if="validationErrors.progressType"
                        v-text="validationErrors.progressType"
                      ></small>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <label>Sort</label>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <v-select
                                class="v-search-select"
                                placeholder=""
                                label="text"
                                v-model="exportParam.sortBy"
                                :options="sortBy"
                                :clearable="true"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.value"
                              >
                                <template #search="{ attributes, events }">
                                  <input
                                    class="vs__search"
                                    name="sortBy"
                                    :required="!exportParam.sortBy"
                                    v-bind="attributes"
                                    v-on="events"
                                  />
                                </template>
                              </v-select>
                              <small
                                class="form-text text-danger"
                                v-if="validationErrors.sortBy"
                                v-text="validationErrors.sortBy"
                              ></small>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <div class="d-flex">
                                <label class="cursor-pointer mb-0 mt-5">
                                  <input
                                    type="radio"
                                    class="control-radio"
                                    value="true"
                                    :checked="exportParam.sortDirection == true"
                                    v-model="exportParam.sortDirection"
                                  />
                                  <span
                                    class="pl-5 font-weight-normal v-align-middle"
                                    >Oldest</span
                                  >
                                </label>
                                <label class="cursor-pointer mb-0 mt-5 pl-20">
                                  <input
                                    type="radio"
                                    class="control-radio"
                                    value="false"
                                    :checked="
                                      exportParam.sortDirection == false
                                    "
                                    v-model="exportParam.sortDirection"
                                  />
                                  <span
                                    class="pl-5 font-weight-normal v-align-middle"
                                    >Newest</span
                                  >
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Filter</label>
                      <v-select
                        class="v-search-select"
                        placeholder=""
                        label="text"
                        v-model="exportParam.filterType"
                        :options="filters"
                        :clearable="false"
                        :searchable="true"
                        :filterable="true"
                        :reduce="(option) => option.value"
                      >
                      </v-select>
                    </div>
                    <div
                      class="form-group"
                      v-if="exportParam.filterType === 'Provider'"
                    >
                      <label>{{ exportParam.filterType }}</label>
                      <multiselect
                        v-model="exportParam.providerIds"
                        :options="providers"
                        :multiple="true"
                        :close-on-select="false"
                        :limit="1"
                        placeholder="Select provider"
                        label="name"
                        track-by="id"
                      ></multiselect>
                    </div>
                    <div
                      class="form-group"
                      v-if="exportParam.filterType === 'Booker'"
                    >
                      <label>Company's {{ exportParam.filterType }}</label>
                      <multiselect
                        v-model="exportParam.bookerCompanyIds"
                        :options="companies"
                        :multiple="true"
                        :close-on-select="false"
                        :limit="1"
                        placeholder="Select booker"
                        label="name"
                        track-by="id"
                      ></multiselect>
                    </div>
                    <div
                      class="form-group"
                      v-if="exportParam.filterType === 'Passenger'"
                    >
                      <label>Company's {{ exportParam.filterType }}</label>
                      <multiselect
                        v-model="exportParam.passengerCompanyIds"
                        :options="companies"
                        :multiple="true"
                        :close-on-select="false"
                        :limit="1"
                        placeholder="Select passenger"
                        label="name"
                        track-by="id"
                      ></multiselect>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click.prevent="exportToExcel()"
                      >
                        Export
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import tenantReportService from "@/services/shop/report/tenantReportService.js";
import providerService from "@/services/master/provider/providerService.js";
import companyService from "@/services/master/company/companyService.js";

export default {
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToExport: function () {
      return this.allPermissions.includes("Export");
    },
    recordInfo: function () {
      return this.requestParams.totalRecords > 1
        ? `${this.requestParams.totalRecords} Records`
        : `${this.requestParams.totalRecords} Record`;
    },
    isAirportType: function () {
      return this.requestParams.serviceType === "AirportTransfer";
    },
    isHourlyType: function () {
      return this.requestParams.serviceType === "Rental";
    },
    queryParams() {
      return {
        companyIds: this.requestParams.companyIds,
        serviceType: this.requestParams.serviceType,
        keyword: this.requestParams.keyword,
        status: this.requestParams.status,
        paymentStatus: this.requestParams.paymentStatus,
        progress: this.requestParams.progress,
        pickupDate: this.requestParams.pickupDate,
        sortBy: this.requestParams.sortBy,
        sortDirection: this.requestParams.sortDirection,
        sort: this.requestParams.sort,
        page: this.requestParams.page,
        pageSize: this.requestParams.pageSize,
      };
    },
    queryParamsString() {
      const paramsString = Object.entries(this.queryParams)
        .filter(
          ([key, value]) =>
            value !== null &&
            value !== undefined &&
            value !== "Unspecified" &&
            value !== "" &&
            key !== "totalPages" &&
            key !== "totalRecords"
        )
        .map(([key, value]) => {
          if (key === "pickupDate") {
            return `pickupFromDate=${encodeURIComponent(
              value.start
            )}&pickupToDate=${encodeURIComponent(value.end)}`;
          } else {
            return `${key}=${encodeURIComponent(value)}`;
          }
        })
        .join("&");

      return paramsString.length > 0 ? `?${paramsString}` : "";
    },
    generateQueryParams() {
      let queryParams = Object.entries(this.exportParam)
        .filter(
          ([key, value]) =>
            value !== null &&
            value !== undefined &&
            value !== "Unspecified" &&
            value !== "" &&
            key !== "filterType" &&
            key !== "filterDate"
        )
        .map(([key, value]) => {
          if (key === "pickupRange") {
            return `pickupFromDate=${encodeURIComponent(
              value.start
            )}&pickupToDate=${encodeURIComponent(value.end)}`;
          } else if (key === "reservationRange") {
            return `reservationFromDate=${encodeURIComponent(
              value.start
            )}&reservationToDate=${encodeURIComponent(value.end)}`;
          } else if (Array.isArray(value)) {
            if (value.length) {
              let x = "";
              for (const item of value) {
                x += `&${key}=${encodeURIComponent(item.id)}`;
              }
              return x.slice(1);
            }
          } else if (key === "sortDirection") {
            if (value) {
              return `${key}=${encodeURIComponent("desc")}`;
            }
            return `${key}=${encodeURIComponent("asc")}`;
          } else {
            return `${key}=${encodeURIComponent(value)}`;
          }
        })
        .filter((val) => val !== undefined)
        .join("&");

      return `?${queryParams}`;
    },
  },
  data() {
    return {
      validationErrors: {
        status: null,
        paymentStatus: null,
        progressType: null,
        sortby: null,
        filter: null,
      },
      exportParam: {
        filterDate: null,
        pickupRange: null,
        reservationRange: null,
        status: null,
        paymentStatus: null,
        progress: null,
        sortBy: null,
        sortDirection: false,
        filterType: null,
        providerIds: [],
        bookerCompanyIds: [],
        passengerCompanyIds: [],
      },
      filters: [],
      providers: [],
      companies: [],
      paymentStatus: [],
      statusTypes: [],
      progressTypes: [],
      sortBy: [],
      filterDateOption: [],
      rentalLabel: null,
      airportLabel: null,
      allPermissions: [],
      items: [],
      isLoading: false,
      msg: "Please wait",
      requestParams: {
        companyIds: null,
        keyword: "",
        serviceType: "Unspecified",
        status: "",
        paymentStatus: "",
        progress: "",
        pickupDate: null,
        sortBy: "nearest_pickup_date",
        sortDirection: "asc",
        sort: "nearest_pickup_date_asc",
        page: 1,
        pageSize: 25,
        totalPages: 1,
        totalRecords: 0,
      },
      sortByOption: [
        {
          value: "nearest_pickup_date_asc",
          label: "Nearest Pick-up Date",
        },
        {
          value: "pickup_date_desc",
          label: "Latest Pick-up Date",
        },
        {
          value: "pickup_date_asc",
          label: "Oldest Pick-up Date",
        },
        {
          value: "reservation_date_desc",
          label: "Latest Reservation Date",
        },
        {
          value: "reservation_date_asc",
          label: "Oldest Reservation Date",
        },
      ],
      pageSizeOption: [25, 50, 100],
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.rentalLabel = this.$helper.extractSetting(
      publicSettings,
      "RentalLabel",
      "Hourly"
    );
    this.airportLabel = this.$helper.extractSetting(
      publicSettings,
      "AirportLabel",
      "Airport"
    );

    this.setupRequestParams();

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      this.statusTypes = [
        { value: "Tentative", text: "Tentative" },
        { value: "Confirmed", text: "Confirmed" },
        { value: "Cancelled", text: "Cancelled" },
      ];

      this.paymentStatus = [
        { value: "MonthlyInvoice", text: "Monthly Invoice" },
        { value: "Completed", text: "Completed" },
      ];

      this.progressTypes = [
        { value: "Pending", text: "Pending" },
        { value: "Run", text: "Run" },
        { value: "Done", text: "Done" },
        { value: "UnderReview", text: "Under Review" },
        { value: "Closed", text: "Closed" },
        { value: "Rescue", text: "Rescue" },
      ];

      this.sortBy = [
        { value: "pickup_date", text: "Pick-Up Date" },
        { value: "reservation_date", text: "Reservation Date" },
      ];

      this.filters = [
        { value: "None", text: "None" },
        { value: "Provider", text: "Provider" },
        { value: "Booker", text: "Booker" },
        { value: "Passenger", text: "Passenger" },
      ];

      this.filterDateOption = [
        { value: "Pick-Up Date", text: "Pick-Up Date" },
        { value: "Reservation Date", text: "Reservation Date" },
      ];

      this.getProviders();
      await this.getCompanies();
      this.getReportList();
    }
  },
  mounted() {
    document.addEventListener("keydown", this.handleEnter);
  },
  updated() {
    this.$helper.collapseMenu("booking-history");
    this.$helper.setNavigationClass("tenant-report-link");

    $(".help-tip").popover({ trigger: "hover" });
  },
  methods: {
    handleEnter(e) {
      if (e.key !== "Enter") return;
      if (document.body.classList.contains("modal-open")) {
        return;
      }

      e.preventDefault();
      this.onSearchReportList(true);
    },
    setupRequestParams() {
      this.requestParams.companyIds = this.$route.query.companyIds || null;
      this.requestParams.page = Number(this.$route.query.page) || 1;
      this.requestParams.pageSize = this.$route.query.pageSize || 25;
      this.requestParams.keyword = this.$route.query.keyword || "";
      this.requestParams.sortBy =
        this.$route.query.sortBy || "nearest_pickup_date";
      this.requestParams.sortDirection =
        this.$route.query.sortDirection || "asc";
      this.requestParams.sort =
        this.$route.query.sort || "nearest_pickup_date_asc";
      this.requestParams.status = this.$route.query.status || null;
      this.requestParams.paymentStatus =
        this.$route.query.paymentStatus || null;
      this.requestParams.progress = this.$route.query.progress || null;
      this.requestParams.serviceType =
        this.$route.query.serviceType || "Unspecified";
      this.requestParams.pickupDate =
        this.$route.query.pickupFromDate && this.$route.query.pickupToDate
          ? {
              start: this.$route.query.pickupFromDate,
              end: this.$route.query.pickupToDate,
            }
          : null;
    },
    async getReportList() {
      this.isLoading = true;
      try {
        const response = await tenantReportService.getReportList(
          this.queryParamsString
        );

        if (response.data == null) {
          this.$notification.error("No reservation found", { title: "Error" });
          this.items = [];
          return;
        }
        this.items = response.data.items;
        this.requestParams.totalPages = response.data.totalPages;
        this.requestParams.totalRecords = response.data.totalItems;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    onChangeServiceType(value) {
      this.requestParams.serviceType = value;

      this.onSearchReportList();
    },
    onSelectSort(value) {
      if (value.includes("reservation")) {
        this.requestParams.sortBy = "reservation_date";

        if (value.includes("_asc")) {
          this.requestParams.sortDirection = "asc";
        } else {
          this.requestParams.sortDirection = "desc";
        }
      }

      if (value.includes("pickup")) {
        if (value === "nearest_pickup_date_asc") {
          this.requestParams.sortBy = "nearest_pickup_date";
        } else {
          this.requestParams.sortBy = "pickup_date";
        }

        if (value.includes("_asc")) {
          this.requestParams.sortDirection = "asc";
        } else {
          this.requestParams.sortDirection = "desc";
        }
      }

      this.onSearchReportList();
    },
    onSearchReportList(fromFilter = false) {
      if (fromFilter) this.requestParams.page = 1;
      const path = `/report/tenant${this.queryParamsString}`;
      if (this.$route.path !== path) this.$router.push(path);
    },
    resertFilter() {
      this.requestParams = {
        ...this.requestParams,
        keyword: "",
        companyIds: null,
        keyword: "",
        paymentStatus: "",
        status: "",
        progress: "",
        pickupDate: null,
      };

      if (Object.keys(this.$route.query).length > 0) {
        this.$router.replace("/report/tenant");
      }
    },
    async onChangePageSize() {
      this.onSearchReportList();
    },
    async onNavigateCallback(pageNumber) {
      this.requestParams.page = pageNumber;
      this.onSearchReportList();
    },
    async getProviders() {
      this.providers = await providerService.getAllActive();
    },
    async getCompanies() {
      this.companies = await companyService.getAllActive();
    },
    open(reservation) {
      const pathUrl = `/reservation/inquiry/`;
      const routeData = this.$router.resolve({
        path: pathUrl + reservation.id,
      });
      window.open(routeData.href, "_blank");
    },
    onChangeFilterDate(value) {
      const thisMonth = new Date();
      const selectedDate = `${
        thisMonth.getMonth() + 1
      }/${thisMonth.getDate()}/${thisMonth.getFullYear()}`;

      if (value === "Pick-Up Date") {
        this.exportParam.reservationRange = null;
        this.exportParam.pickupRange = {
          start: selectedDate,
          end: selectedDate,
        };
      }

      if (value === "Reservation Date") {
        this.exportParam.pickupRange = null;
        this.exportParam.reservationRange = {
          start: selectedDate,
          end: selectedDate,
        };
      }
    },
    openExportModal() {
      const thisMonth = new Date();
      const selectedDate = `${
        thisMonth.getMonth() + 1
      }/${thisMonth.getDate()}/${thisMonth.getFullYear()}`;
      this.exportParam.pickupRange = {
        start: selectedDate,
        end: selectedDate,
      };
      this.exportParam.filterDate = "Pick-Up Date";
      this.exportParam.sortBy = "pickup_date";
      this.exportParam.filterType = "None";
      this.exportParam.providerIds = [];
      this.exportParam.bookerCompanyIds = [];
      this.exportParam.passengerCompanyIds = [];
      $(this.$refs.exportmodal).modal({ backdrop: "static", keyboard: false });
    },
    async exportToExcel() {
      this.isLoading = true;
      try {
        const response = await tenantReportService.exportReportToExcel(
          this.generateQueryParams
        );

        if (response.data.isReportExist) {
          const link = document.createElement("a");
          link.href = `data:application/octet-stream;charset=utf-8;base64,${response.data.content}`;
          link.target = "_blank";
          link.download = `${response.data.name}.xlsx`;
          link.click();
        } else {
          this.$notification.warning("Report not found", { title: "Warning" });
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    isAirportTransfer(serviceType) {
      return serviceType.toLowerCase() === "airporttransfer";
    },
    humanize(value) {
      return this.$helper.humanize(value);
    },
    changeStatusFilter() {
      if (this.requestParams.status === "Cancelled") {
        this.requestParams.progress = "";
      }

      if (this.requestParams.status === "Tentative") {
        this.requestParams.paymentStatus = "";
      }
    },
    changeStatusExport() {
      if (this.exportParam.status === "Cancelled") {
        this.exportParam.progress = "";
      }

      if (this.exportParam.status === "Tentative") {
        this.exportParam.paymentStatus = "";
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleEnter);
  },
  watch: {
    "$route.params": {
      deep: true,
      handler: function (value) {
        this.getReportList();
      },
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/report/ReportTenant.vue